import type { HelpFile } from '../../types/help'
import { ErrorLogsTestIds } from '../../../testids/ErrorLogsTestIds'

export const errorLogsHelp: HelpFile = {
  docPage: '/docs/admin/error-log',
  texts: {
    [ErrorLogsTestIds.systemFailuresPage]:
      'Systemfehlerprotokoll für Backend-Ausnahmen und Frontend-Fehler. Volltextsuche durchsucht ausschließlich die Fehlermeldung — mindestens 3 Zeichen erforderlich.',
    [ErrorLogsTestIds.errorLogsList]:
      'Erfasste Backend-Ausnahmen und Frontend-Fehler durchsuchen — Zeitraumfilter und Tabs helfen beim Eingrenzen.',
    [ErrorLogsTestIds.tabs]:
      'Zwei Ansichten desselben Fehlerstroms: „Alle Datensätze" zeigt jedes einzelne Vorkommen, „Muster" gruppiert wiederkehrende Fehler nach Meldung und Ausnahmetyp.',
    [ErrorLogsTestIds.tabAllRecords]:
      'Jedes Fehlerereignis als separate Zeile, sortiert nach Zeitstempel.',
    [ErrorLogsTestIds.tabPatterns]:
      'Wiederkehrende Fehler nach Meldung und Ausnahmetyp gruppiert — nach Anzahl sortieren zeigt die häufigsten Fehler.',
    [ErrorLogsTestIds.allRecordsCount]: null,
    [ErrorLogsTestIds.patternsCount]: null,
    [ErrorLogsTestIds.allRecordsTable]:
      'Eine Zeile pro erfasstem Fehler — in eine Zeile klicken öffnet Stack-Trace, Anfragekontext und zugehörige Sitzung.',
    [ErrorLogsTestIds.patternsTable]:
      'Eine Zeile pro Fehlermuster (gleicher Ausnahmetyp und gleiche Meldung) — zeigt Häufigkeit und letzten Zeitstempel.',
    [ErrorLogsTestIds.statCards]:
      'Übersichts-Kacheln pro Quellmodul — zeigen, wie viele Fehler im gewählten Zeitfenster aufgetreten sind.',
    [ErrorLogsTestIds.statCardTotal]:
      'Gesamtzahl der Fehler im gewählten Zeitfenster über alle Module.',
    [ErrorLogsTestIds.statCardOthers]:
      'Fehler ohne zugeordnetes Quellmodul — meist Infrastruktur oder unbekannte Herkunft.',
    [ErrorLogsTestIds.statsLoading]:
      'Fehleranzahl pro Modul wird geladen.',
    [ErrorLogsTestIds.filterPeriod]:
      'Angezeigte Fehler auf ein Zeitfenster eingrenzen — letzte Stunde, letzter Tag, letzte Woche oder benutzerdefinierter Bereich.',
    [ErrorLogsTestIds.allMinQHint]:
      'Volltextsuche benötigt mindestens 3 Zeichen vor der Datenbankabfrage.',
    [ErrorLogsTestIds.patternsMinQHint]:
      'Volltextsuche über Muster benötigt mindestens 3 Zeichen vor der Datenbankabfrage.',
    [ErrorLogsTestIds.emptyStateCard]:
      'Keine Fehler für den aktuellen Filter — entweder ist das System in diesem Zeitfenster fehlerfrei oder der Filter ist zu eng.',
    [ErrorLogsTestIds.colAllTime]: null,
    [ErrorLogsTestIds.colAllType]:
      'Einstufung des Fehlerereignisses — Ausnahme, Warnung oder Frontend-Bericht.',
    [ErrorLogsTestIds.colAllException]:
      'Name der Ausnahmeklasse, wie von der Laufzeit gemeldet.',
    [ErrorLogsTestIds.colAllMessage]:
      'Fehlermeldung — Volltextsuche durchsucht nur diese Spalte.',
    [ErrorLogsTestIds.colAllModule]:
      'Quellmodul, das den Fehler erzeugt hat — Modulname oder „frontend" für browserseitige Fehler.',
    [ErrorLogsTestIds.colAllSourceType]:
      'Ob der Fehler im Backend, Frontend oder in einer externen Integration entstanden ist.',
    [ErrorLogsTestIds.colAllSessionId]:
      'Sitzungskennung — im Request-Inspector den vollständigen Anfragefluss einsehen.',
    [ErrorLogsTestIds.colPatternCount]:
      'Anzahl der Vorkommen dieses Musters im gewählten Zeitfenster.',
    [ErrorLogsTestIds.colPatternException]:
      'Ausnahmeklasse aller Vorkommen dieses Musters.',
    [ErrorLogsTestIds.colPatternMessage]:
      'Repräsentative Meldung dieses Musters — variable Teile (IDs, Zeitstempel) sind normalisiert.',
    [ErrorLogsTestIds.colPatternModule]:
      'Quellmodul, aus dem dieses Fehlermuster stammt.',
    [ErrorLogsTestIds.colPatternLastSeen]:
      'Zeitstempel des letzten Vorkommens dieses Musters.',
    [ErrorLogsTestIds.btnRefresh]: null,
    [ErrorLogsTestIds.btnClearAll]:
      'Alle Fehlerprotokoll-Einträge dauerhaft löschen — Bestätigungsdialog wird geöffnet.',
    [ErrorLogsTestIds.btnConfirmClearAll]:
      'Endgültiges Löschen aller Fehlerprotokoll-Einträge bestätigen — dieser Vorgang kann nicht rückgängig gemacht werden.',
    [ErrorLogsTestIds.btnCancelClearAll]: null,
  },
}
